import AbstractConfig from "../../../core/config/AbstractConfig";
import InternalStakeholderDefinition from "./InternalStakeholderDefinition";

export default class InternalStakeholdersConfig extends AbstractConfig {
    constructor() {
        super();

        this._memoizedInternalStakeholders = null;
    }

    /**
     * @returns {Array<InternalStakeholderDefinition>}
     */
    get internalStakeholders() {
        if (this._memoizedInternalStakeholders) {
            return this._memoizedInternalStakeholders;
        }

        const internalStakeholdersObj = this.getValue('internalStakeholders');

        const internalStakeholderDefinitions = [];
        for (let i = 0; i < internalStakeholdersObj.length; i++) {
            const internalStakeholderObj = internalStakeholdersObj[i];
            const internalStakeholder = new InternalStakeholderDefinition(internalStakeholderObj.id);

            internalStakeholderDefinitions.push(internalStakeholder);
        }

        this._memoizedInternalStakeholders = internalStakeholderDefinitions;
        return this._memoizedInternalStakeholders;
    }
}
